// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"15511a8f","513":"2bb6f597","787":"df6b7dc9"}[chunkId] + ".chunk.js";
};